import { TransitionStatus } from 'react-transition-group/Transition';

import { MenuLayerLevel } from '../types';

import styles from './LeftMenu.module.scss';

export const layerLevelStyles: Record<MenuLayerLevel, string> = {
  0: styles.level0,
  1: styles.level1,
  2: styles.level2,
  3: styles.level3,
};

export const layerTransitionStyles: Record<TransitionStatus, string | undefined> = {
  entering: undefined,
  entered: styles.visible,
  exiting: undefined,
  exited: undefined,
  unmounted: undefined,
};
